export default __webpack_public_path__ + "static/media/Snd_TryJ.8431f2d1.mp3";